import script from "./articleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./articleDetail.vue?vue&type=script&setup=true&lang=js"

import "./articleDetail.vue?vue&type=style&index=0&id=38a20b48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a20b48"]])

export default __exports__